import styled from "styled-components";

const StyledWrapper = styled.section`
  align-items: center;
  background: linear-gradient(0deg, #6c195a, #1c112b);
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding-top: 50px;
  padding-inline: 40px;
  width: 100%;
`;

export { StyledWrapper };
